export const getJourneyObjectTypeId = report => {
  return report.getIn(['journeyQuery', 'objectQuery', 'table', 'objectTypeId']);
};
export const getJourneyObjectFilters = report => {
  return report.getIn(['journeyQuery', 'objectQuery', 'filtering']);
};